<script lang="ts">
  import WorkOrderContactTags from "../../../../../../../_shared/_modules/work-order-contact-tags"
  import type { WorkOrderRow } from "../../../../_logic/work-order-table-model"

  type Props = {
    row: WorkOrderRow
  }

  const { row }: Props = $props()
</script>

<WorkOrderContactTags
  tags={row.recipientTags}
  stacked={true}
  splitRoleAndName={true}
  prefixRoleSubLabel={false}
/>
